<script>
import { mapActions, mapState } from 'vuex';
import columns from '@/pages/promotions/giftCardCodes/columns';
import ModalWrapper from '@/components/modals/Modal-wrapper.vue';
import moreInfoAboutClubCard from '@/pages/promotions/giftCardCodes/moreInfo/More-info-about-club-card.vue';
import createForeverClubCard from '@/pages/promotions/giftCardCodes/createCard/Create-forever-club-card.vue';

export default {
  components: {
    ModalWrapper,
    moreInfoAboutClubCard,
    createForeverClubCard,
  },
  data() {
    return {
      columns: columns(),
      showCreate: false,
      showMore: false,
      selectedId: null,
      current: 1,
      pageSize: 10,
      offset: 0,
      sortingParams: {},
    };
  },
  methods: {
    ...mapActions({
      getForeverClubCardsAction: 'promotions/getForeverClubCards',
      deleteForeverClubCardsAction: 'promotions/deleteForeverClubCard',
    }),
    openCreateWindow() {
      this.showCreate = true;
    },
    openInfoWindow(id) {
      this.selectedId = id;
      this.showMore = true;
    },
    deleteClubCard(id) {
      this.deleteForeverClubCardsAction({
        id,
        limit: this.pageSize,
        offset: this.offset,
        sortingParams: this.sortingParams,
      });
    },
    setPagination(count) {
      this.current = count;
    },
    getForeverClubCards() {
      const payload = {
        limit: this.pageSize,
        offset: this.offset,
        ...this.sortingParams,
      };
      this.getForeverClubCardsAction(payload);
    },
    onChangeSorting(type) {
      this.offset = (this.current - 1) * this.pageSize;
      const paramsSort = `sort[${type}]`;
      const sortingType = this.sortingParams[paramsSort] && this.sortingParams[paramsSort] === 'desc' ? 'asc' : 'desc';
      this.sortingParams = { [paramsSort]: sortingType };
      this.getForeverClubCards();
    },
  },
  mounted() {
    this.getForeverClubCards();
  },
  computed: {
    ...mapState({
      foreverClubCards: (state) => state.promotions.foreverClubCards,
      foreverClubCardsTotal: (state) => state.promotions.foreverClubCardsTotal,
    }),
  },
  watch: {
    current(newValue) {
      this.offset = (newValue - 1) * this.pageSize;
      this.getForeverClubCards();
    },
    pageSize() {
      if (this.current === 1) {
        this.getForeverClubCards();
      }
      this.current = 1;
    },
  },
};
</script>

<template>
  <div class="create-button">
    <a-button
      class="sort-button"
      type="primary"
      html-type="button"
      @click="onChangeSorting('id')"
    >
      Sort club card
    </a-button>
    <a-button
      type="primary"
      html-type="button"
      @click="openCreateWindow"
    >
      Create club card
    </a-button>
  </div>
  <div v-if="showCreate">
    <create-forever-club-card
      v-model:show="showCreate"
      :page-size="pageSize"
      :offset="offset"
      :sorting-params="sortingParams"
    />
  </div>
  <a-table
    :columns="columns"
    :dataSource="foreverClubCards"
    :pagination="false"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'actions'">
        <div class="action-buttons">
          <a-button
            type="primary"
            html-type="button"
            @click="openInfoWindow(record.id)"
          >
            More
          </a-button>
          <div v-if="showMore && selectedId === record.id">
            <modal-wrapper v-model:show="showMore">
              <more-info-about-club-card :club-card="record"/>
            </modal-wrapper>
          </div>
          <a-popconfirm title="Sure to delete?" @confirm="deleteClubCard(record.id)">
            <a-button type="primary" html-type="button" danger>
              Delete
            </a-button>
          </a-popconfirm>
        </div>
      </template>
    </template>
  </a-table>
  <div class="pagination" >
    <a-pagination
      v-model:current="current"
      v-model:pageSize="pageSize"
      :total="foreverClubCardsTotal"
      show-less-items
      @change="setPagination"
    />
  </div>
</template>

<style scoped lang="scss">
.create-button, .pagination {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
}
.sort-button {
  margin-right: auto;
}
.action-buttons {
  display: flex;
  flex-direction: row;
}

button:last-child {
  margin-left: 20px;
}
</style>
